import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
import RelatedVideo from "./RelatedVideo";
import VideoContainer from "./VideoContainer";
import VideoRelatedProducts from "./VideoRelatedProducts";
import { Video } from "~/common/Store/models/Video";

interface VideoModel extends Video {
  id: number;
  title: string;
  description: string;
  hiddenDescription: string;
  transcript: string;
  facebookShareUrl: string;
  twitterShareUrl: string;
  pinterestShareUrl: string;
  relatedProducts: Product[];
  relatedVideos: {
    title: string;
    image: string;
    description: string;
    link: string;
  }[];
  youtubeId: string;
}

interface Props {
  displayHeader: string;
  videoModel: VideoModel;
}

export default function FoodServiceResourcesVideo({
  displayHeader,
  videoModel,
}: Props) {
  return (
    <div className="container" data-module="foodServiceResourcesVideo">
      <h1 className="page-header">{displayHeader}</h1>
      <div id="page" className="product-page video-special">
        <div className="container-video">
          <VideoContainer {...{ ...videoModel }} />
          {videoModel.relatedProducts && (
            <VideoRelatedProducts
              relatedProducts={videoModel.relatedProducts}
            />
          )}
        </div>
        {videoModel.relatedVideos && videoModel.relatedVideos.length > 0 && (
          <>
            <p className="header-2 clears">Related Videos</p>
            <div className="rel-vid-cont">
              {videoModel.relatedVideos.map((video) => (
                <RelatedVideo {...{ ...video }} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
